import React,{useEffect} from 'react'
import {projectCreationStepFilter } from '../../redux/reducers/ProjectCreationStepSlice';
import { useSelector, useDispatch } from "react-redux";
import $ from "jquery";
import Constants from '../../Constants';
const projectCreationSteps = [
	"Source Material Step 1",
	"Source Material Step 2",
	"Language and Reference Material",
	"Project Information",
	"Translation Request",
	"Workflow Step 1",
	"Workflow Step 2",
	"Project Summary"
];

export default function RightNavigationBar() {

    
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const projectCreationStep = useSelector((projectCreationStepSlice) => projectCreationStepSlice.project_creation_step).value;
	const asyncAssetUploadInfo = useSelector(reduxStore => reduxStore.asset_upload_background).value;
	const customerBootstrapData = useSelector((redux) => redux.customer_bootstrap_data).value;
	const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
	const projectContentType = useSelector(reduxStore => reduxStore.content_type_for_project_creation).value;

    function expandRightFunction() {        
        var element = document.getElementById("container");
        element.classList.toggle("expand-right");
		document.getElementById("container").classList.remove("expand-left");
		$('.step-list .left-burgur-menu').attr('aria-expanded', function(index, attr){
			return attr === 'true' ? 'false': 'true';
		  });
    }

    function changeProjectCreationStep(step){
		if ($(document.activeElement).attr('tabindex')==='-1') {
			return;
		} else {
			dispatch(projectCreationStepFilter(step));
			checkPage(urlParams.get("step"))
		}
    }

	const checkPage = (step) => {
		if(projectCreationSteps.indexOf(step) < projectCreationSteps.indexOf(urlParams.get("step")?urlParams.get("step"):projectCreationStep)) {
			if(step === "Source Material Step 2") {
				let status = "success";
				asyncAssetUploadInfo.validationErrors.map(validationError => {
					const data = { ...validationError };
					if((validationError.status === Constants.WARNING || projectContentType === Constants.ELOQUA) && projectContentType !== Constants.MARKETOREST) {
						return status;
					} else {
						if(data.error !== "") {
							status = "failed";
						}
					}
				});
				return status;
			} else {
				return "success";
			}
			
		} else if(projectCreationSteps.indexOf(step) > projectCreationSteps.indexOf(urlParams.get("step")?urlParams.get("step"):projectCreationStep)) {
			return "locked"
		} else {
			return "active"
		}
	}
  return (
    <aside className="left-sidebar step-list">
				<ul role="tablist">
					<li role="none">
					   <button role="tab" className="left-burgur-menu" onClick={expandRightFunction} aria-label="Step expand list" aria-expanded="false" createproject-tour="right-navigation">
						<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
							<g clipPath="url(#clip0_1730_20423)">
							<path d="M11.861 4.27771C11.8615 4.35813 11.8461 4.43786 11.8157 4.51232C11.7852 4.58677 11.7404 4.65449 11.6838 4.7116L5.39546 10.9999L11.6838 17.2883C11.7839 17.4052 11.8362 17.5555 11.8303 17.7094C11.8243 17.8632 11.7606 18.009 11.6517 18.1179C11.5429 18.2267 11.397 18.2905 11.2432 18.2964C11.0894 18.3024 10.939 18.25 10.8221 18.1499L3.66602 10.9999L10.8221 3.84382C10.9079 3.75973 11.0166 3.70278 11.1346 3.68011C11.2525 3.65743 11.3746 3.67003 11.4854 3.71633C11.5963 3.76262 11.691 3.84057 11.7578 3.94041C11.8246 4.04026 11.8605 4.15758 11.861 4.27771Z" fill="#1D4ED8"></path>
							<path d="M18.5837 4.27771C18.5841 4.35813 18.5687 4.43786 18.5383 4.51232C18.5079 4.58677 18.4631 4.65449 18.4065 4.7116L12.1181 10.9999L18.4065 17.2883C18.5066 17.4052 18.5589 17.5555 18.5529 17.7094C18.547 17.8632 18.4832 18.009 18.3744 18.1179C18.2656 18.2267 18.1197 18.2905 17.9659 18.2964C17.8121 18.3024 17.6617 18.25 17.5448 18.1499L10.3887 10.9999L17.5448 3.84382C17.6306 3.75973 17.7392 3.70278 17.8572 3.68011C17.9752 3.65743 18.0972 3.67003 18.2081 3.71633C18.3189 3.76262 18.4137 3.84057 18.4805 3.94041C18.5473 4.04026 18.5832 4.15758 18.5837 4.27771Z" fill="#1D4ED8"></path>
							</g>
							<defs>
							<clipPath id="clip0_1730_20423">
							<rect width="22" height="22" fill="white" transform="translate(0 22) rotate(-90)"></rect>
							</clipPath>
							</defs>
						</svg>
					   </button>
					</li>
					<li role="none" createproject-tour="lock-navigation" className={projectCreationStep==="Source Material Step 1" ? "active" : checkPage("Source Material Step 2")} onClick={()=>changeProjectCreationStep("Source Material Step 2")}>
						<p className='sourceTab' role="tab" to="#" tabIndex={checkPage("Source Material Step 1") === "locked" ? -1 : 0}
						 aria-label={projectCreationStep==="Source Material Step 1"  ? 'Current tab Source Material':'Source Material' && checkPage("Source Material Step 1" || 'Source Material Step 2') === "locked" ? 'unavailable Source Material' : 'Source Material' }
						 aria-selected={projectCreationStep==="Source Material Step 1"  ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Source Material</strong>
						</p>
					</li>
					<li role="none" className={checkPage("Language and Reference Material")} onClick={()=>changeProjectCreationStep("Language and Reference Material")}>
						<p  role="tab"   tabIndex={checkPage("Language and Reference Material") === "locked" ? -1 : 0}
					     aria-label={projectCreationStep === "Language and Reference Material" ? 'Current tab Language and Reference Materials':'Language and Reference Materials' && checkPage("Language and Reference Material") === "locked" ? 'unavailable Language and Reference Materials' : 'Language and Reference Materials' }
						 aria-selected={projectCreationStep === "Language and Reference Material" ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Language &amp; Reference Materials</strong>
						</p>
					</li>
					<li role="none" className={checkPage("Project Information")} onClick={()=>changeProjectCreationStep("Project Information")}>
						<p  role="tab"   tabIndex={checkPage("Project Information") === "locked" ? -1 : 0}
						aria-label={projectCreationStep === "Project Information" ? 'Current tab, Project Information':'Project Information' && checkPage("Project Information") === "locked" ? 'unavailable Project Information' : 'Project Information' }
						aria-selected={projectCreationStep === "Project Information" ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Project Information</strong>
						</p>
					</li>
					<li role="none" className={checkPage("Translation Request")} onClick={()=>changeProjectCreationStep("Translation Request")}>
						<p  role="tab"   tabIndex={checkPage("Translation Request") === "locked" ? -1 : 0}
					    	aria-label={projectCreationStep === "Translation Request" ? 'Current tab, Translation Request':'Translation Request' && checkPage("Translation Request") === "locked" ? 'unavailable Translation Request' : 'Translation Request' }
							aria-selected={projectCreationStep === "Translation Request" ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Translation Request</strong>
						</p>
					</li>
					<li role="none" className={projectCreationStep === "Workflow Step 1" ? "active" : checkPage("Workflow Step 2")} onClick={()=>changeProjectCreationStep("Workflow Step 1")}>
						<p  role="tab"   tabIndex={checkPage("Workflow Step 1" || "Workflow Step 2") === "locked" ? -1 : 0}
						aria-label={projectCreationStep === "Workflow Step 1" || projectCreationStep === "Workflow Step 2" ? 'Current tab, Workflow and Followers':'Workflow and Followers' && checkPage("Workflow Step 1" && "Workflow Step 2") === "locked" ? 'unavailable Workflow and Followers' : 'Workflow and Followers' }
						aria-selected={projectCreationStep === "Workflow Step 1" || projectCreationStep === "Workflow Step 2" ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Workflow and Followers</strong>
						</p>
					</li>
					<li role="none" className={checkPage("Project Summary")} onClick={()=>changeProjectCreationStep("Project Summary")}>
						<p  role="tab"   tabIndex={checkPage("Project Summary") === "locked" ? -1 : 0}
						aria-label={projectCreationStep === "Project Summary" ? 'Current tab, Project Summary':'Project Summary' || checkPage("Project Summary") === "locked" ? 'unavailable Project Summary' : '' }
						aria-selected={projectCreationStep === "Project Summary" ? 'true':'false'}
						>
							<span className="project-icon flex-center"></span>
							<strong>Project Summary</strong>
						</p>
					</li>
				</ul>
			</aside>
  )
}
